
import { Card, IconButton, ModalWindow } from "@/shared/ui";
import { Aspect as AspectComponent } from "@/entities";
import { defineComponent } from "vue";
import { Aspect, AspectType } from "@/types";
import { EditAspect } from "@/features";
import { useCharactersStore } from "@/app/store/CharacterStore";
import { storeToRefs } from "pinia";

export default defineComponent({
	name: "AspectSection",
	components: { EditAspect, IconButton, ModalWindow, AspectComponent, Card },
	setup() {
		const store = useCharactersStore();

		const { characters, current } = storeToRefs(store);
		const { updateAspects } = store;

		return {
			characters,
			current,
			updateAspects,
		};
	},
	data() {
		return {
			modal: false,
		};
	},
	computed: {
		AspectType() {
			return AspectType;
		},
	},
	methods: {
		update(aspect: Aspect, id: number) {
			const newAspects = [...this.characters[this.current].aspects];
			newAspects.splice(id, 1, aspect);
			this.updateAspects(newAspects);
		},
		remove(id: number) {
			this.updateAspects(
				this.characters[this.current].aspects.filter(
					(e: Aspect, i: number) => i !== id
				)
			);
		},
		add(aspect: Aspect) {
			this.updateAspects([
				...this.characters[this.current].aspects,
				aspect,
			]);
		},
	},
});
